<div id="critical-error" class="pap-mat-primary" *ngIf="criticalError">
  <div class="error-message">
    <strong>Critical Error occurred</strong>
  </div>

  <img src="assets/img/error/critical-error-jigsaw.png" style="height: 400px;">

  <div>
    <strong>{{ criticalError.name }}:</strong> {{ criticalError.message }}
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/error/error.component.html